// This icon file is generated automatically.
var PTabletOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.5 0h-9a1 1 0 00-1 1v12a1 1 0 001 1h9a1 1 0 001-1V1a1 1 0 00-1-1zm-.13 12.88H2.63V1.12h8.75v11.75zm-5-1.63a.62.62 0 101.25 0 .62.62 0 00-1.25 0z", "fill-rule": "nonzero" } }] }, "name": "p-tablet", "theme": "outlined" };
export default PTabletOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PTabletOutlined.js
// module id = 3679
// module chunks = 0